import React from "react";
import "./Privacy.css";
import { Container } from "react-bootstrap";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

const Privacy = () => {
  return (
    <div>
      <div className="privacy_section">
        <div className="privacy">
          <Header />
          <Container>
            <h4>
              <b>IF YOU DO NOT AGREE, PLEASE DO NOT USE OR ACCESS THE APPLICATION:</b>
            </h4>
            <p>
              This privacy policy applies to Mobile application- Splendid (“Application”). which is
              operated and managed by the Splendid App Private Limited (“Company”).
            </p>
            <h2>What Information do we collect:</h2>
            <p>
              In the context of this Privacy Policy, the term "personal information" refers to data
              that identifies, relates to, describes, is reasonably capable of being associated
              with, or could reasonably be linked, directly or indirectly, to you as an individual.
              It excludes aggregated or de- identified information maintained in a form not
              reasonably capable of being associated with or linked to you. We collect information
              you provide directly to us, such as when you create or modify your account, request
              on-demand services, contact customer support, or otherwise communicate with us. This
              information may include: name, email, phone number, postal address, profile picture,
              payment method, items requested (for delivery services), delivery notes, and other
              information you choose to provide. All the information provided to us by you,
              including sensitive personal information, is voluntary. If you update any information
              relating to you, we may keep a copy of the information which you originally provided
              to us in its archives. Due to the communications standards on the Internet, when you
              visit the Website, we automatically receive the URL of the site from which you came
              and the site to which you are going when you leave. We also receive the Internet
              Protocol (IP) address of your computer (or the proxy server you used to access the
              World Wide Web), your computer operating system and type of web browser you are using,
              email patterns, as well as the name of your internet service provider (ISP). Our
              services may involve the collection of location information by third-party providers.
              These third parties may automatically obtain and process data related to your general
              geographic location based on various sources, including but not limited to internet
              protocol (IP) addresses, GPS data, and other location-identifying technologies. The
              purpose of collecting this location information is to enhance the functionality of our
              services, provide personalized content, and improve user experiences.
            </p>
            <h2>Why do we collect this information?</h2>
            <p>
              Information collected is used to analyse overall trends to help us improve our
              service. The Application uses temporary cookies to store certain data (that is not
              sensitive personal data or information) that is used by us and our service providers
              for the technical administration of the Application, research and development, and for
              administration. In the course of serving advertisements or optimizing services to you,
              we may allow authorized third parties to place or recognize a unique cookie on your
              browser.
            </p>
            <p>In general, we collect such information in order to:</p>
            <ol>
              <li>
                <p>
                  Provide, maintain, and improve our services, including, for example, to facilitate
                  payments, send receipts, provide products you request (and send related
                  information), develop new features, provide customer support to Users, develop
                  safety features, authenticate users, and send product updates and administrative
                  messages;
                </p>
              </li>
              <li>
                <p>
                  Perform internal operations, including, for example, to prevent fraud and abuse of
                  our products; to troubleshoot software bugs and operational problems; to conduct
                  data analysis, testing, and research; and to monitor and analyse usage and
                  activity trends;
                </p>
              </li>
              <li>
                <p>
                  Send you communications we think will be of interest to you, including information
                  about products, promotions, news, and events of the Application and to process
                  contest, sweepstake, or other promotion entries and fulfil any related awards;
                </p>
              </li>
              <li>
                <p>
                  Personalize and improve the product and related services, including to provide or
                  recommend features, content, social connections, referrals, and advertisements
                </p>
              </li>
            </ol>

            <p>
              While you are on our server, it is imperative to recognize that your information may
              also be collected, used, and shared by various entities beyond our control. These
              entities encompass your mobile service provider, mobile operating system provider,
              third-party applications on your device, social media platforms, websites that you
              access, and other third-party operators.
            </p>
            <h2>How do we process this information?</h2>
            <p>
              We process personal information based on legal grounds, such as the necessity for the
              performance of a contract, compliance with legal obligations, and consent when
              applicable.
            </p>
            <ol type="a">
              <li>
                <p>
                  We do not store personally identifiable information in the cookies. We may keep
                  records of telephone calls received and made for making inquiries, orders or other
                  purposes for the purpose of administration of services, research and development,
                  quality management services and for proper administration. We allow other
                  companies to serve advertisements to you. These companies include third party ad
                  servers, ad agencies, ad technology vendors and research firms. We may “target”
                  some ads to you that fit a certain general profile. We do NOT use personally
                  identifiable information to target ads.
                </p>
              </li>
              <li>
                <p>
                  We may share some of the aggregate findings and details with advertisers,
                  sponsors, investors, strategic partners and others in order to help grow our
                  business without obtaining any approval from you.
                </p>
              </li>
              <li>
                <p>
                  We do not disclose any personal information to advertisers and for other marketing
                  and promotional purposes that could be used to personally identify you, your
                  password, credit card number and bank account number.
                </p>
              </li>
              <li>
                <p>
                  The Application may integrate with social sharing features and other related tools
                  which let you share actions you take on our products with other apps, sites, or
                  media, and vice versa. Your use of such features enables the sharing of
                  information with your friends or the public, depending on the settings you
                  establish with the social sharing service. Please refer to their privacy policies
                  for more information about how they handle the data you provide to or share
                  through them. Our promotional offers/discounts are not sitewide and are limited to
                  selected categories / geographies. Coupon codes may not be applicable on all
                  products or such product as may be determined by us in our sole discretion.
                </p>
              </li>
              <li>
                <p>
                  We may allow others to provide audience measurement and analytics services for us,
                  to serve advertisements on our behalf across the Internet and to track and report
                  on the performance of those advertisements. These entities may use cookies and
                  other technologies to identify your device when you visit our app/website and use
                  our products, as well as when you visit other online sites and products.
                </p>
              </li>
            </ol>

            <h2>Your rights on your information:</h2>
            <p>
              You have the right to withdraw your consent at any time, in accordance with the terms
              and conditions of the Application, but please note that withdrawal of consent will not
              be retroactive. You can access, modify, correct and eliminate the data about you which
              has been collected pursuant to your decision to become a user of the Application.
            </p>

            <h2>Meta Permissions:</h2>
            <p>
              "Meta permissions" - Prior to accessing specific endpoints for app user data, the
              application must receive consent from the app user to obtain all necessary permissions
              associated with that particular endpoint.
            </p>
            <p>
              To enable the full functionality of the Feature, the Company has requested the
              following Meta permissions:
            </p>
            <ol>
              <li>pages_show_list: Authorization to access a list of pages managed by the user.</li>
              <li>
                pages_manage_metadata: Permission to manage metadata for pages administered by the
                user.
              </li>
              <li>
                instagram_manage_comments: Authority to manage and respond to comments on Instagram
                posts.
              </li>
              <li>
                business_management: Access required for handling business-related functionalities.
              </li>
              <li>instagram_manage_messages: Permission to manage Direct Messages on Instagram.</li>
              <li>instagram_basic: Essential access to basic Instagram account information. </li>
            </ol>
            <p>
              Granting these Meta permissions is necessary for the seamless operation of the app.
            </p>
            <h2>User Control:</h2>
            <p>
              Users reserve the right to cancel or disable the Feature at any given time. Cancelling
              the Feature will result in the revocation of the granted Meta permissions associated
              with it. It is expressly acknowledged that the activation and utilization of the
              Feature are entirely optional. Users retain the discretion to choose whether or not to
              enable the Feature. By choosing to activate and utilize the o Feature, users expressly
              agree to the terms outlined in this document, including the granting of Meta
              permissions. Users acknowledge the optional nature of the Feature and affirmatively
              consent to the Company's access to the specified Meta permissions for the purpose of
              Feature functionality.
            </p>
            <h2>Legal Implications and Exclusions:</h2>
            <p>
              We assume no responsibility and shall not be liable for any damages to, or viruses
              that may infect your equipment on account of your access to, use of, or browsing the
              Application or the downloading of any material, data, text, images, video content, or
              audio content from the Application
            </p>
            <p>
              If you are dissatisfied with the Application, your sole remedy is to discontinue using
              the Application. We do not exercise control over the sites displayed as search results
              or links from within its services. These other sites may place their own cookies or
              other files on your computer, mobile device and collect data or solicit personal
              information from you, for which we are not responsible or liable. Accordingly, we do
              not make any representations concerning the privacy practices or policies of such
              third parties or terms of use of such websites/mobile applications, nor do we
              guarantee the accuracy, integrity, or quality of the information, data, text,
              software, sound, photographs, graphics, videos, messages or other materials available
              on such websites/mobile applications. The inclusion or exclusion does not imply any
              endorsement by us of the website/mobile application, the website’s/mobile applications
              provider, or the information on the website/mobile application. We encourage you to
              read the privacy policies of that website/mobile application.
            </p>
            <p>
              The Application may enable you to communicate with other users or to post information
              to be accessed by others, whereupon other users may collect such data. We hereby
              expressly disclaim any liability for any misuse of such information that is made
              available by visitors in such a manner. We value the privacy of information pertaining
              to our users. The linkage between your IP address and your personally identifiable
              information is not shared with third-parties without your permission or except when
              required by law. We will enable you to communicate your privacy concerns to us and
              that we will respond to them appropriately.
            </p>
            <h2>Data Protection Mechanisms:</h2>
            <p>
              We are committed to ensuring the security of your sensitive personal information. To
              protect your data, we implement various security measures including, but not limited
              to:
            </p>
            <p>Encryption of sensitive data both in transit and at rest.</p>
            <p>
              Restricted access to sensitive information, ensuring only authorized personnel can
              access it.
            </p>
            <p>
              Regular audits and monitoring of our systems to detect any vulnerabilities or
              potential breaches.
            </p>
            <p>Implementation of secure storage mechanisms to safeguard personal information.</p>
            <p>
              These measures help prevent unauthorized access, use, or disclosure of your data,
              ensuring its confidentiality and integrity.
            </p>

            <h2>Retention and Deletion of Google User Data:</h2>
            <p>
              We retain Google user data only for as long as is necessary to fulfill the purposes
              outlined in this privacy policy, or as required by applicable law. Once this data is
              no longer required, we will delete it in accordance with our data retention policy.
              Users may request the deletion of their data at any time by contacting our support
              team at&nbsp;
              <a href="mailto:hello@splendid.app" target="_blank" rel="noreferrer">
                hello@splendid.app
              </a>
              . Upon receiving such a request, we will take reasonable steps to delete the user’s
              personal data, unless retention is necessary for compliance with a legal obligation or
              the protection of our legitimate interests. This retention and deletion policy is in
              line with international data protection regulations, including the GDPR and CCPA.
            </p>

            <h2>General:</h2>
            <p>
              We may change this Privacy Policy from time to time. If we make significant changes in
              the way we treat your personal information or to the Privacy Policy, we will provide
              you notification on the website / email. Your continued use of the Application to
              purchase products/browse after such notice constitutes your consent to the changes. We
              encourage you to periodically review the Privacy Policy for the latest information on
              our privacy practices.
            </p>
            <p className="mb-5">
              For any questions or concerns regarding your data, please contact our Privacy Team at{" "}
              <a href="mailto:hello@splendid.app" target="_blank" rel="noreferrer">
                hello@splendid.app
              </a>
            </p>
          </Container>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Privacy;
